export const CUSTOMER_AGENT_AUTOMATED_MESSAGE = 'CUSTOMER_AGENT_AUTOMATED_MESSAGE';